import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";

import { SpondHeaderComponent } from "./components/spondHeader";
import { SpondFooterComponent } from "./components/spondFooter";
import { SpinnerComponent } from "./components/spinner";

import { ReplaceHighlightPipe } from "./pipes/replaceHighlight.pipe";
import { RemoveHighlightPipe } from "./pipes/removeHighlight.pipe";

import { GroupCoverImageComponent } from "./components/groupCoverImage/groupCoverImage.component";

@NgModule({
    imports: [CommonModule, BrowserModule],
    declarations: [
        SpondHeaderComponent,
        SpondFooterComponent,
        SpinnerComponent,
        GroupCoverImageComponent,
        ReplaceHighlightPipe,
        RemoveHighlightPipe,
    ],
    providers: [],
    exports: [
        SpondHeaderComponent,
        SpondFooterComponent,
        SpinnerComponent,
        GroupCoverImageComponent,
        ReplaceHighlightPipe,
        RemoveHighlightPipe,
    ],
})
export class SpondCommonModule {}
